import { render, staticRenderFns } from "./supplyCard.vue?vue&type=template&id=2fe72e43&scoped=true"
import script from "./supplyCard.vue?vue&type=script&lang=js"
export * from "./supplyCard.vue?vue&type=script&lang=js"
import style0 from "./supplyCard.vue?vue&type=style&index=0&id=2fe72e43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe72e43",
  null
  
)

export default component.exports